import React, { useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery, Menu } from '@mui/material';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import queryString from 'query-string';
import styles from './Dragon_Tiger/styles.module.css';
import AllBet from './Aviator/AllBet/AllBet';
import Dragon_Tiger from './Dragon_Tiger/Dragon_Tiger';
import DragonTigerLion from './Dragon_Tiger_Lion/DragonTigerLion';
import MyBetsScreen from '../MyBetsScreen/MyBetsScreen';
import BollywoodCasino from './Bollywood_Casino/BollywoodCasino';
import BetScreen from './Dragon_Tiger/BetScreen';
import AmarAkbarAnthony from './Amar_Akbar_Anthony/AmarAkbarAnthony';
import AndarBahar from '../CasinoBet/AndarBahar/AndarBahar';
import TwoCardTeenPati from './TwoCardTeenPati/TwoCardTeenPati';
import Card32 from './Card32/Card32';
import TeenPatiTtweenty from './TeenPatiTtweenty/TeenPatiTtweenty';
import Bsccarat from './Baccarat/Baccarat';
import Lucky7 from './Lucky7/Lucky7';
import Day1DragonTiger from './Day1DragonTiger/Day1DragonTiger';
import Roulette from './Roulette/Roulette';
import BetsTable from './Roulette/BetsTable/BetsTable';
import Aviator from './Aviator/Aviator';
import AviatorMyBet from './Aviator/AviatorMyBet/AviatorMyBet';
import { useDispatch, useSelector } from 'react-redux';
import useGameSocket from '../../api/useGameSocket';
import useSettledRounds from '../../api/useSettledRounds';
import useAviatorSocket from '../../api/useAviatorSocket';
import useCasinoBetplace from '../../api/useCasinoBetplace';
import { GetEditStake } from '../../store/slices/sportsSlice';

import RulesModal from './Rulesmodal';
import { GAME_RULES } from './Gamerules';
import InstantGame from '../InstantGame/Instantgame';
import age from '../../images/18plus.png';
import git from '../../images/gt.png';
import gamecare from '../../images/gamecare.png';
import ssl from '../../images/ssl.png';

const GAME_IDS = {
    'Andar Bahar': 5,
    'Aviator': 2,
    'Roulete': 3,
    'Dragon Tiger': 6,
    'One Day Dragon Tiger': 13,
    '32 Cards': 12,
    'Amar Akbar Anthony': 11,
    'Teen Patti T20': 1,
    'Bollywood Casino': 8,
    'Lucky 7': 4,
    '2 Card Teen Patti': 9,
    'Dragon Tiger Lion': 7,
    'Baccarat': 10,
    'InstantGame':14,
};

const gameOptions = [
    'Andar Bahar',
    'Aviator',
    'Roulete',
    'Dragon Tiger',
    'One Day Dragon Tiger',
    '32 Cards',
    'Amar Akbar Anthony',
    'Teen Patti T20',
    'Bollywood Casino',
    'Lucky 7',
    '2 Card Teen Patti',
    'Dragon Tiger Lion',
    'Baccarat',
    'InstantGame',
];

function CasinoBetTab() {
    
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const isDesktopView = useMediaQuery('(min-width:1023px)');
    const isAuthenticated = useSelector((state) => state.auth.authenticated);

    const [selectedGame, setSelectedGame] = useState(() => {
        const gameParam = searchParams.get('game');
        return gameParam && gameOptions.includes(decodeURIComponent(gameParam))
            ? decodeURIComponent(gameParam)
            : gameOptions[0];
    });

    const [value, setValue] = useState(0);
    const [gameId, setGameId] = useState(GAME_IDS[selectedGame] || 14);
    const { socketData } = useGameSocket(gameId);
    const { settledData } = useSettledRounds(gameId, socketData?.roundId);

useEffect(() => {

}, [gameId, selectedGame]);     

    const aviatorData = useAviatorSocket();
     const aviatorSocket = aviatorData;
 
    const [locked, setLocked] = useState(false);
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth.userId);
    const [anchorEl, setAnchorEl] = useState(null);
    const [betDialogOpen, setBetDialogOpen] = useState(false);
    const [selectedBet, setSelectedBet] = useState(null);
    const [myBetsCount, setMyBetsCount] = useState(0);
const [pinnedSettlement, setPinnedSettlement] = useState(null);
const [pinnedRoundId, setPinnedRoundId] = useState(null);


const currentRoundId = selectedGame === 'Aviator'
    ? (aviatorSocket?.roundId ?? null)
    : (socketData?.roundId ?? null);

    const [rulesOpen, setRulesOpen] = useState(false);


   const { bets: casinoBets, exposureData } = useCasinoBetplace(gameId, socketData, currentRoundId);
    const editStakeData = useSelector((state) => state.sports.GetEditStakeData || []);

    useEffect(() => {
        if (!userId) return;
        dispatch(GetEditStake({ userId, GAME: 'CASINO' }));
    }, [dispatch, userId]);

 useEffect(() => {
    if (selectedGame === 'Aviator') {
        if (aviatorSocket) setLocked(aviatorSocket.bettingClosed === true);
    } else {
        if (socketData) setLocked(socketData.bettingClosed === true);
    }
}, [selectedGame, socketData, aviatorSocket]);

    useEffect(() => {
        const gameParam = searchParams.get('game');
        if (gameParam && gameOptions.includes(decodeURIComponent(gameParam))) {
            const decodedGame = decodeURIComponent(gameParam);
            if (decodedGame !== selectedGame) {
                setSelectedGame(decodedGame);
                setGameId(GAME_IDS[decodedGame]);
            }
        }
    }, [searchParams, selectedGame]);

    const handleGameClick = (event) => setAnchorEl(event.currentTarget);
    const handleGameClose = () => setAnchorEl(null);

    const handleGameSelect = (game) => {
        setSelectedGame(game);
        setGameId(GAME_IDS[game]);
        setSearchParams({ game: encodeURIComponent(game) });
        handleGameClose();
    };

    const gameComponents = {

               'InstantGame': (
            <InstantGame
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
            />
        ),

        'Andar Bahar': (
            <AndarBahar
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                  hookExposureData={exposureData}   
              gameId={gameId}  
            />
        ),
        'Roulete': (
            <Roulette
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
            />
        ),
        'Aviator': <Aviator socketData={aviatorSocket} showAllBet={!isDesktopView} />,
        'Dragon Tiger': (
            <Dragon_Tiger
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData} gameName={selectedGame}
                settledData={socketData?.settlement || settledData}
                casinoBets={casinoBets}
             hookExposureData={exposureData}   
              gameId={gameId}  
            />
        ),
        'One Day Dragon Tiger': (
            <Day1DragonTiger
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
            />
        ),
      '32 Cards': (
    <Card32
        onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
        locked={locked} socketData={socketData}
        settledData={socketData?.settlement || settledData}
        hookExposureData={exposureData}
        gameId={gameId}
    />

        ),
        'Amar Akbar Anthony': (
            <AmarAkbarAnthony
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                  hookExposureData={exposureData} 
            />
        ),
        'Teen Patti T20': (
            <TeenPatiTtweenty
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                 hookExposureData={exposureData}
                  gameId={gameId}
            />
        ),
        'Bollywood Casino': (
            <BollywoodCasino
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                  hookExposureData={exposureData}
                  gameId={gameId}
            />
        ),
        'Lucky 7': (
            <Lucky7
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                hookExposureData={exposureData}
                gameId={gameId}
            />
        ),
        '2 Card Teen Patti': (
            <TwoCardTeenPati
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                hookExposureData={exposureData}
                gameId={gameId}
            />
        ),
        'Dragon Tiger Lion': (
            <DragonTigerLion
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                   hookExposureData={exposureData}
            />
        ),
        'Baccarat': (
            <Bsccarat
                onBetSelect={(bet) => { if (!isAuthenticated) { navigate('/login'); return; } setSelectedBet(bet); setBetDialogOpen(true); }}
                locked={locked} socketData={socketData}
                settledData={socketData?.settlement || settledData}
                 hookExposureData={exposureData}   
              gameId={gameId} 
            />
        ),
    };

    const containerStyle = {
        backgroundColor: selectedGame === 'Aviator' ? '#131617' : 'inherit',
    };

    const casinoAmountList = React.useMemo(() => {
        const casinoData = editStakeData.filter(item => item.type === 'CASINO');
        if (casinoData.length === 0) return undefined;
        return casinoData
            .map(item => ({
                label: item.overridden ? item.userLabel : item.globalLabel,
                value: item.overridden ? parseFloat(item.userValue) : parseFloat(item.globalValue),
            }))
            .filter(item => !isNaN(item.value) && item.value > 0)
            .sort((a, b) => a.value - b.value);
    }, [editStakeData]);

const betScreenProps = {
    open: betDialogOpen,
    onClose: () => { setBetDialogOpen(false); setSelectedBet(null); },
    selectedBet,
    gameId,
    gameName: selectedGame,
    roundId: currentRoundId,
    amountList: casinoAmountList,
    socketData: socketData, 
};

    return (
        <Box className={styles.Main_Container}>

            <RulesModal
                open={rulesOpen}
                onClose={() => setRulesOpen(false)}
                title={selectedGame}
                rulesText={GAME_RULES[selectedGame] || 'Rules coming soon.'}
            />

            <Box className={styles.header_container}>
                <Box className={styles.header_top}>
                    <Box onClick={() => navigate(-1)} sx={{ cursor: 'pointer' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 12L6 8L10 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Box>
                    <Box className={styles.game_select} sx={{ cursor: 'pointer' }} onClick={handleGameClick}>
                        <Typography className={styles.MenuItem_txt} sx={{ cursor: 'pointer' }}>
                            {selectedGame}
                        </Typography>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                            <path d="M9 1L5 5L1 1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Box>
                    <Box>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleGameClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            PaperProps={{ className: styles.customMenu }}
                        >
                            {gameOptions.map((game) => (
                                <Box
                                    key={game}
                                    onClick={() => handleGameSelect(game)}
                                    sx={{ cursor: 'pointer' }}
                                    className={`${styles.customMenuItem} ${selectedGame === game ? styles.customMenuItemSelected : ''}`}
                                >
                                    <Typography
                                        sx={{ cursor: 'pointer' }}
                                        className={`${styles.customMenuItemText} ${selectedGame === game ? styles.customMenuItemSelectedText : ''}`}
                                    >
                                        {game}
                                    </Typography>
                                </Box>
                            ))}
                        </Menu>
                    </Box>

                    <Typography
                        className={styles.rules_text}
                        onClick={() => setRulesOpen(true)}
                        sx={{ cursor: 'pointer' }}
                    >
                        Rules
                    </Typography>
                </Box>
            </Box>

            {isDesktopView ? (
                <Box className={styles.isDesktopView_container} sx={containerStyle}>
                    <Box className={styles.MatchScreen_container}>

                        {/* ✅ DESKTOP: Round ID yahan dikh raha hai - flex row mein */}
                        <Box
                            className={styles.sectionTitle_container}
                            sx={{
                                display: 'flex !important',
                                flexDirection: 'row !important',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Box className={styles.sectionTitle_box}>
                                <Typography className={styles.sectionTitle}>GAME</Typography>
                            </Box>
                           <Typography
    sx={{
        color: '#fff',
        fontSize: '12px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
    }}
>
    Round ID: {selectedGame === 'Aviator' 
        ? aviatorSocket?.roundId ?? 'NA'
        : socketData?.roundId ?? 'NA'
    }
</Typography>
                        </Box>

                        <Box sx={{ width: '100%', cursor: 'pointer' }}>
                            {gameComponents[selectedGame] || (
                                <Typography sx={{ color: '#fff', textAlign: 'center', marginTop: 2 }}>
                                    {selectedGame} is not available yet.
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    <Box className={styles.other_tab}>
                        {selectedGame !== 'Roulete' && selectedGame !== 'Aviator' && (
                            <Box className={styles.sectionTitle_container}>
                                <Box className={styles.sectionTitle_box}>
                                    <Typography className={styles.sectionTitle}>BETSLIP</Typography>
                                </Box>
                            </Box>
                        )}
                        {selectedBet && <BetScreen {...betScreenProps} />}
                        <Box className={styles.sectionTitle_container}>
                            <Box className={styles.sectionTitle_box}>
                                <Typography className={styles.sectionTitle}>MY BETS</Typography>
                            </Box>
                        </Box>
                        {selectedGame === 'Roulete' ? (
                            <BetsTable 

                              roundId={currentRoundId}
                               casinoBets={casinoBets}
                            
                            />
                        ) : selectedGame === 'Aviator' ? (
                            <AviatorMyBet 
                         
                          roundId={currentRoundId}
                             
                            />
                        ) : (
                            <MyBetsScreen
                                gmid={gameId}
                                roundId={currentRoundId}
                                casinoBets={casinoBets}
                                onBetCountChange={(count) => { }}
                            />
                        )}
                        {selectedGame === 'Aviator' && <AllBet />}
                    </Box>
                </Box>
            ) : (
                <Box className={styles.tab_content} sx={containerStyle}>
                    {selectedBet && (
                        <Box className={styles.betDialogOpen_container2}>
                            <Box className={styles.betDialogOpen_container234}>
                                <BetScreen {...betScreenProps} />
                            </Box>
                        </Box>
                    )}

                    {/* ✅ MOBILE: Round ID yahan dikh raha hai tabs ke saath */}
                    <Box
                        value={value}
                        className={styles.tabs}
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                    >
                       <Box
    className={`${styles.tabRoot} ${value === 0 ? styles.tabSelected : ''}`}
    onClick={() => setValue(0)}
>
    <Typography className={`${styles.tabLabelText} ${value === 0 ? styles.tabLabelTextSelected : ''}`}>
        GAME
    </Typography>
</Box>
<Box
    className={`${styles.tabRoot2} ${value === 1 ? styles.tabSelected : ''}`}
    onClick={() => setValue(1)}
   
>
    <Typography className={`${styles.tabLabelText} ${value === 1 ? styles.tabLabelTextSelected : ''}`}>
        MY BETS ({myBetsCount})
    </Typography>
</Box>
                        {/* ✅ MOBILE Round ID - marginLeft auto se right side pe push hoga */}
                        <Box sx={{ marginLeft: 'auto', padding: '0 8px' }}>
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: '11px',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                Round ID: {currentRoundId || 'NA'}
                            </Typography>
                        </Box>
                    </Box>

                  <Box className={styles.Main_Container}>
    <Box sx={{ display: value === 0 ? 'block' : 'none' }}>
        {gameComponents[selectedGame] || (
            <Typography sx={{ color: '#fff', textAlign: 'center', marginTop: 2 }}>
                {selectedGame} is not available yet.
            </Typography>
        )}
    </Box>

    <Box sx={{ display: value === 1 ? 'block' : 'none' }}>
        {selectedGame === 'Roulete' ? (
            <BetsTable />
        ) : selectedGame === 'Aviator' ? (
            <AviatorMyBet roundId={currentRoundId} />
        ) : (
            <MyBetsScreen
                gmid={gameId}
                roundId={currentRoundId}
                casinoBets={casinoBets}
                onBetCountChange={setMyBetsCount}
            />
        )}
    </Box>
</Box>
                </Box>
            )}
          <Box
                sx={{
                    background: 'linear-gradient(135deg, #0a7fc2 0%, #0a5f9c 100%)',
                    padding: '10px 16px',
                    textAlign: 'center',
                    width: '100%',
                    alignSelf: 'stretch',
                    boxSizing: 'border-box',
                    maxWidth: '100%',
                }}
            >
                <Typography
                    sx={{
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '20px',
                    }}
                >
                    24X7 Support
                </Typography>
                <Typography
                    component="a"
                    href="https://wa.link/mewin01"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        color: 'rgba(255,255,255,0.85)',
                        fontSize: '13px',
                        mb: 1,
                        display: 'inline-block',
                        textDecoration: 'none',
                        cursor: 'pointer',
                        '&:hover': {
                            color: '#fff',
                        },
                    }}
                >
                    https://wa.link/mewin01
                </Typography>

                <Box
                    component="a"
                    href="https://wa.link/mewin01"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        backgroundColor: '#25D366',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                        textDecoration: 'none',
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.148.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
                            fill="#fff"
                        />
                        <path
                            d="M12.004 2C6.486 2 2 6.486 2 12.004c0 1.887.52 3.653 1.42 5.164L2 22l4.955-1.396A9.945 9.945 0 0012.004 22C17.522 22 22 17.522 22 12.004 22 6.486 17.522 2 12.004 2zm0 18.09a8.08 8.08 0 01-4.14-1.135l-.297-.176-2.94.828.833-2.867-.194-.297a8.08 8.08 0 01-1.264-4.44c0-4.47 3.632-8.104 8.102-8.104 4.47 0 8.102 3.634 8.102 8.104 0 4.47-3.632 8.087-8.102 8.087z"
                            fill="#fff"
                        />
                    </svg>
                </Box>
            </Box>

            <Box
                sx={{
                    background: '#fff',
                    padding: '20px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1.5,
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 2, py: 1.5, mt: -5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: -2 }}>
                        <Box
                            component="img"
                            src={ssl}
                            alt="Secure SSL"
                            sx={{ width: 110, height: 110, objectFit: 'contain', flexShrink: 0 }}
                        />
                        <Box sx={{ textAlign: 'left' }}>
                            <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#212121', lineHeight: 1.3 }}>
                                100% SAFE
                            </Typography>
                            <Typography sx={{ fontSize: '10px', color: '#000', lineHeight: 1.3 }}>
                                Protected connection and encrypted data.
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, width: '100%', mt: -4, mb: -5 }}>
                        <Box
                            component="img"
                            src={age}
                            alt="18+"
                            sx={{
                                width: 30,
                                height: 30,
                                borderRadius: '50%',
                                border: '2px solid #d32f2f',
                                objectFit: 'cover',
                            }}
                        />
                        <Box
                            component="img"
                            src={gamecare}
                            alt="GamCare"
                            sx={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover' }}
                        />
                        <Box
                            component="img"
                            src={git}
                            alt="GT"
                            sx={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover' }}
                        />
                    </Box>
                </Box>
            </Box>

        </Box>
    );
}

export default CasinoBetTab;